import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function TravelTimeRuleAPI(): BringozApi {
  return {
    base: `/travelRule`,
    // infiniteScroll: {
    //   address: `/travelRule`,
    //   cmd: 'GET'
    // },
    actions: {
      getRules: {
        address: '{vehicleType}',
        cmd: 'GET',
        updateable: false
      },
      createRule: {
        address: '',
        cmd: 'PUT',
        updateable: false
      },
      updateRule: {
        address: '{id}',
        cmd: 'POST',
        updateable: false
      },
      deleteRule: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: false
      }
    }
  }
}
angular
  .module('bringoz.admin.site-preferences')
  .factory('TravelTimeRuleAPI', TravelTimeRuleAPI);
